import React, { PropTypes, PureComponent } from 'react';
import cx from 'classnames';
import { keyCodes, standardIcons } from '../../util/constants';
import { Icon } from 'react-fast-ui';
import FormControl from './FormControl';
import DelayedChangeInput from './DelayedChangeInput';

export default class SearchInput extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
  };

  static defaultProps = {
    disabled: false,
    placeholder: 'Search'
  };

  // Render methods
  renderClearIcon() {
    const { onChange, value } = this.props;
    const classes = cx(
      { 'cursor-pointer hover-color-danger': value, 'color-transparent': !value },
      'mg-right-sm',
      'xl-font'
    );

    return (
      <span className={classes} onClick={() => onChange('')}>×</span>
    );
  }

  handleEscape = e => {
    if (e.keyCode === keyCodes.KEY_ESCAPE) {
      const { onChange } = this.props;

      e.preventDefault();
      e.stopPropagation();

      onChange('');
    }
  };

  focus = () => this.refs.input.focus();

  render() {
    const { className, disabled, onChange, placeholder, value } = this.props;

    return (
      <div className={cx('cursor-pointer relative display-block', className)}>
        <FormControl>
          <DelayedChangeInput
            disabled={disabled} onChange={onChange} onKeyDown={this.handleEscape}
            placeholder={placeholder} ref="input" type="text" value={value || ''}
          />
        </FormControl>
        <span className="absolute top-sm right-md line-height-1">
          {this.renderClearIcon()}
          <Icon
            className="cursor-pointer color-primary hover-color-primary" name={standardIcons.search} size="lg"
            onClick={this.focus}
          />
        </span>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/inputs/SearchInput.jsx